var _rect, _path, _path2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicfileicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "#F0FCF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 17.4711C17.9167 17.0734 17.9167 16.8745 17.9998 16.7635C18.0722 16.6667 18.1831 16.6062 18.3036 16.5976C18.442 16.5877 18.6093 16.6952 18.9438 16.9103L22.8777 19.4392C23.168 19.6258 23.3131 19.7192 23.3633 19.8378C23.4071 19.9415 23.4071 20.0585 23.3633 20.1622C23.3131 20.2808 23.168 20.3742 22.8777 20.5608L18.9438 23.0897C18.6093 23.3048 18.442 23.4123 18.3036 23.4024C18.1831 23.3938 18.0722 23.3333 17.9998 23.2365C17.9167 23.1255 17.9167 22.9266 17.9167 22.5289V17.4711Z",
    stroke: "#2EB358",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.5C12.5 15.0999 12.5 14.3998 12.7725 13.865C13.0122 13.3946 13.3946 13.0122 13.865 12.7725C14.3998 12.5 15.0999 12.5 16.5 12.5H23.5C24.9001 12.5 25.6002 12.5 26.135 12.7725C26.6054 13.0122 26.9878 13.3946 27.2275 13.865C27.5 14.3998 27.5 15.0999 27.5 16.5V23.5C27.5 24.9001 27.5 25.6002 27.2275 26.135C26.9878 26.6054 26.6054 26.9878 26.135 27.2275C25.6002 27.5 24.9001 27.5 23.5 27.5H16.5C15.0999 27.5 14.3998 27.5 13.865 27.2275C13.3946 26.9878 13.0122 26.6054 12.7725 26.135C12.5 25.6002 12.5 24.9001 12.5 23.5V16.5Z",
    stroke: "#2EB358",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#34CB65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicfileicon);
export default __webpack_public_path__ + "static/media/music file icon.94ac41b6df09a9e1d412a97578d908ec.svg";
export { ForwardRef as ReactComponent };